/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Permission;
(function (Permission) {
    let permission_value;
    (function (permission_value) {
        permission_value["ALLOWED"] = "ALLOWED";
        permission_value["ALLOWED_BUT_NO_EFFECT"] = "ALLOWED_BUT_NO_EFFECT";
        permission_value["ALLOWED_BUT_NOT_PREFERRED"] = "ALLOWED_BUT_NOT_PREFERRED";
        permission_value["NOT_ALLOWED"] = "NOT_ALLOWED";
        permission_value["NOT_ALLOWED_WITH_CURRENT_FEATURES"] = "NOT_ALLOWED_WITH_CURRENT_FEATURES";
        permission_value["NOT_ALLOWED_LIMIT_REACHED"] = "NOT_ALLOWED_LIMIT_REACHED";
        permission_value["NOT_ALLOWED_IN_ORG"] = "NOT_ALLOWED_IN_ORG";
        permission_value["NOT_POSSIBLE"] = "NOT_POSSIBLE";
    })(permission_value = Permission.permission_value || (Permission.permission_value = {}));
})(Permission || (Permission = {}));
